import { __spreadArray } from "tslib";
import { assertString } from "./assertFunctions";
/**
 * 从组件内部调用/执行 jdwork-web 界面上录入的函数。
 * @param param0 schema 中定义的自定义函数
 * @param context 函数执行上下文
 */
export function execFunction(_a, context) {
    var injectParam = _a.injectParam, functionBody = _a.functionBody;
    assertString(injectParam);
    assertString(functionBody);
    return function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        try {
            var handler = new Function(injectParam, functionBody);
            // @ts-ignore
            return handler.call.apply(handler, __spreadArray([context || this], arg));
        }
        catch (e) {
            console.error(e);
        }
    };
}
